import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { LocationAccuracy } from '@ionic-native/location-accuracy/ngx';
import { LocationService } from 'src/app/services/location/location.service';
import { take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertController, ModalController } from '@ionic/angular';
import { OrderService } from 'src/app/services/order/order.service';

declare let H: any;

@Component({
  selector: 'app-location-map',
  templateUrl: './location.page.html',
  styleUrls: ['./location.page.scss'],
})
export class LocationPage implements OnInit {
  @Input() type: string;
  @Input() searchAddress: string;

  lat;
  lng;
  address;
  selectedAddress;

  map: any;
  defaultLayers;
  platform;
  behavior;
  ui;
  centerMarker;

  addresses = [];

  fromUrl;

  stores = [];

  private mapKey = environment.mapKey;

  constructor(
    private geolocation: Geolocation,
    private locationAccuracy: LocationAccuracy,
    private locationService: LocationService,
    private httpClient: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private alertController: AlertController,
    private modalController: ModalController,
    private orderService: OrderService
  ) {}

  ngOnInit() {
    console.log(this.type);
    this.presentPopUp();
    console.log(this.router.url);
    console.log(this.searchAddress);
    this.route.queryParams.subscribe((params) => {
      this.fromUrl = params.from;
    });
    setTimeout(() => {
      this.platform = new H.service.Platform({
        apikey: environment.mapKey,
      });
      this.defaultLayers = this.platform.createDefaultLayers();

      this.map = new H.Map(
        document.getElementById('map'),
        this.defaultLayers.vector.normal.map,
        {
          center: { lat: -27, lng: 25 },
          zoom: 4,
          pixelRatio: window.devicePixelRatio || 1,
        }
      );

      window.addEventListener('resize', () => this.map.getViewPort().resize());

      this.behavior = new H.mapevents.Behavior(
        new H.mapevents.MapEvents(this.map)
      );

      this.ui = H.ui.UI.createDefault(this.map, this.defaultLayers);

      window.onload = () => {
        this.map.getViewPort().resize();
      };
      this.setUpClickListener(this.map);

      //
      this.selectedAddress = this.searchAddress;
      this.locateAddress(this.searchAddress);
    }, 2000);

    // this.getStores();
  }

  locateMe() {
    this.addresses = [];
    this.selectedAddress = '';
    this.address = '';
    this.locationAccuracy
      .canRequest()
      .then((canRequest: boolean) => {
        if (canRequest) {
          this.locationAccuracy
            .request(this.locationAccuracy.REQUEST_PRIORITY_HIGH_ACCURACY)
            .then(
              () => {
                const watch = this.geolocation.watchPosition({
                  enableHighAccuracy: true,
                  maximumAge: 10000,
                  timeout: 500,
                });
                watch.subscribe((data: any) => {
                  const newLat = data.coords.latitude;
                  const newLng = data.coords.longitude;

                  this.lat = newLat;
                  this.lng = newLng;

                  if (newLat !== this.lat && newLng !== this.lng) {
                    this.lat = newLat;
                    this.lng = newLng;
                    this.addDraggableMarker(this.map, this.behavior);
                  }
                });
              },
              (error) => {
                alert(
                  'Error requesting location permissions' +
                    JSON.stringify(error)
                );
              }
            );
        }
      })
      .catch((error) => {
        // console.log(error);
        this.geolocation.getCurrentPosition().then((pos) => {
          this.lat = pos.coords.latitude;
          this.lng = pos.coords.longitude;
          this.addDraggableMarker(this.map, this.behavior);
        });
      });
  }

  setUpClickListener(map) {
    if (this.centerMarker) {
      this.map.removeObject(this.centerMarker);
    }

    map.addEventListener('dbltap', (evt) => {
      const coord = map.screenToGeo(
        evt.currentPointer.viewportX,
        evt.currentPointer.viewportY
      );

      this.lat = coord.lat;
      this.lng = coord.lng;

      this.addDraggableMarker(this.map, this.behavior);
    });
  }

  addDraggableMarker(map, behavior) {
    if (this.centerMarker) {
      this.map.removeObject(this.centerMarker);
    }

    this.centerMarker = new H.map.Marker(
      { lat: this.lat, lng: this.lng },
      {
        volatility: true,
      }
    );

    this.centerMarker.draggable = true;
    const html = '<div>You can drag me!</div>';
    this.centerMarker.setData(html);
    map.addObject(this.centerMarker);
    map.setCenter({ lat: this.lat, lng: this.lng });
    map.setZoom(18);

    this.centerMarker.addEventListener(
      'tap',
      (evt) => {
        const bubble = new H.ui.InfoBubble(evt.target.getGeometry(), {
          content: evt.target.getData(),
        });
        this.ui.addBubble(bubble);
      },
      false
    );

    map.addEventListener(
      'dragstart',
      (ev) => {
        const target = ev.target;
        const pointer = ev.currentPointer;

        if (target instanceof H.map.Marker) {
          const targetPosition = map.geoToScreen(target.getGeometry());
          target.offset = new H.math.Point(
            pointer.viewportX - targetPosition.x,
            pointer.viewportY - targetPosition.y
          );
          behavior.disable();
        }
      },
      false
    );

    map.addEventListener(
      'dragend',
      (ev) => {
        const target = ev.target;
        if (target instanceof H.map.Marker) {
          behavior.enable();
          // this.lat = target.b.lat;
          // this.lng = target.b.lng;

          this.lat = target.a.lat;
          this.lng = target.a.lng;

          console.log(`dragg  ${this.lat}, ${this.lng}`);
          console.log(ev);
        }
      },
      false
    );

    map.addEventListener(
      'drag',
      (ev) => {
        const target = ev.target;
        const pointer = ev.currentPointer;
        if (target instanceof H.map.Marker) {
          target.setGeometry(
            map.screenToGeo(
              pointer.viewportX - target.offset.x,
              pointer.viewportY - target.offset.y
            )
          );
        }
      },
      false
    );
  }

  onChange(event) {
    const queryAddress = event.detail.value;
    this.address = queryAddress;
    this.selectedAddress = queryAddress;
    if (queryAddress && queryAddress.length > 0) {
      this.search(queryAddress);
    } else {
      this.addresses = [];
    }
  }

  onSelect(addressItem) {
    this.lat = addressItem.position.lat;
    this.lng = addressItem.position.lng;
    this.addresses = [];
    this.addDraggableMarker(this.map, this.behavior);
  }

  addressSelect() {
    this.selectedAddress = this.address;
    const coords = '-25.48115,28.02004';
    const countryCode = 'ZAF';
    const address = this.address;
    const url =
      'https://discover.search.hereapi.com/v1/discover?apiKey=' +
      this.mapKey +
      '&at=' +
      coords +
      '&in=countryCode:' +
      countryCode +
      '&q=' +
      address;

    this.httpClient
      .get(url)
      .pipe(take(1))
      .subscribe((data: any) => {
        const results = data.items;
        this.lat = results[0].position.lat;
        this.lng = results[0].position.lng;
        this.addresses = [];
        this.address = '';
        this.addDraggableMarker(this.map, this.behavior);
      });
  }

  search(q) {
    const coords = '-25.48115,28.02004';
    const countryCode = 'ZAF';
    const address = q;
    const url =
      'https://discover.search.hereapi.com/v1/discover?apiKey=' +
      this.mapKey +
      '&at=' +
      coords +
      '&in=countryCode:' +
      countryCode +
      '&q=' +
      address;

    this.httpClient
      .get(url)
      .pipe(take(1))
      .subscribe((data: any) => {
        this.addresses = data.items;
      });
  }

  locateAddress(address) {
    const coords = '-25.48115,28.02004';
    const countryCode = 'ZAF';
    // const address = q;
    const url =
      'https://discover.search.hereapi.com/v1/discover?apiKey=' +
      this.mapKey +
      '&at=' +
      coords +
      '&in=countryCode:' +
      countryCode +
      '&q=' +
      address;

    this.httpClient
      .get(url)
      .pipe(take(1))
      .subscribe((data: any) => {
        const addresses = data.items;
        const { lat, lng } = addresses[0].position;

        this.lat = lat;
        this.lng = lng;
        this.addDraggableMarker(this.map, this.behavior);
        this.getStores();
      });
  }

  next() {
    this.presentAlert();
  }

  async presentAlert() {
    const alert = await this.alertController.create({
      header: 'Confirm Location',
      message: `The pin point is on <b>${this.selectedAddress}</b> <br> 
      (<i>The pin point can be moved</i>)`,
      buttons: [
        {
          text: 'Cancel',
        },
        {
          text: 'Okay',
          handler: () => {
            if (this.type === 'start-point') {
              console.log(`type ${this.type}`);
              console.log(`${this.lat}, ${this.lng}`);
              this.locationService.setStartCoords(this.lat, this.lng);
              this.locationService.setStartAddress(this.selectedAddress);
              console.log(this.locationService.getStartCoords());
              // this.router.navigate()
              this.goBack();
            } else {
              console.log(`${this.lat}, ${this.lng}`);
              this.locationService.setCoords(this.lat, this.lng);
              this.locationService.setAddress(this.selectedAddress);
              console.log(this.locationService.getCoords());
              // this.router.navigate()
              this.goBack();
            }
          },
        },
      ],
    });

    await alert.present();
  }

  test(e) {
    console.log(e);
  }

  goBack() {
    this.modalController.getTop().then((res) => {
      this.modalController.dismiss();
    });
  }

  async presentPopUp() {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: 'Alert!',
      message: `
        Verify <b>Your Drop Off Location</b> on the map.
        `,
      buttons: [
        {
          text: 'Okay',
        },
      ],
    });

    await alert.present();
  }

  getStores() {
    this.orderService
      .getStorePoints()
      .pipe(take(1))
      .subscribe((res) => {
        this.stores = res.map((store) => ({
          docID: store.payload.doc.id,
          ...(store.payload.doc.data() as Object),
        }));

        // console.log(this.stores);
        this.stores.map((store) => {
          if (store.coords) {
            const { pointName, coords } = store;
            this.createMarker(pointName, coords);
          }
        });
      });
  }

  createMarker(name, coords) {
    const html = `
      <div style="text-align:'center'; ">
        <b>${name}</b>
      </div>
    `;
    const icon = new H.map.Icon('../../../assets/store-front4.png', {
      size: { w: 32, h: 32 },
    });

    const marker = new H.map.Marker(
      { lat: coords.lat, lng: coords.lng },
      {
        icon,
      }
    );

    marker.setData(html);

    this.map.addObject(marker);

    marker.addEventListener(
      'tap',
      (evt) => {
        const bubble = new H.ui.InfoBubble(evt.target.getGeometry(), {
          content: evt.target.getData(),
        });
        this.ui.addBubble(bubble);
      },
      false
    );
  }
}
